<template>
    <section class="row section-global success-page">
        <h1>SUCCESS!</h1>
        <p>An NZXT representative will contact you via email shortly.</p>
        <button class="btn btn-green m-y-md" @click="$emit('start-over')">START OVER</button>
    </section>
</template>

<script>
export default {
    name: "SuccessSection"
}
</script>

<style lang="scss">
.pc-rental {
    .success-page {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background-color: #ececec;

        h1 {
            font-size: 48px;
        }

        p {
            font-size: 20px;
            color: #9B9B9B;
        }

        .btn {
            margin-top: 30px;
        }
    }
}
</style>
